import { Injectable, inject } from '@angular/core';

import { WidgetType } from '@frontend/sports/types/components/widget';
import { WidgetRegistryService } from '@frontend/sports/widget/core/feature';
import { OnFeatureInit } from '@frontend/vanilla/core';

import { RotatingTeaserWidgetComponent } from './rotating-teaser-widget.component';
import { StaticTeaserWidgetComponent } from './static-teaser-widget.component';

@Injectable({ providedIn: 'root' })
export class WidgetRegistrationService implements OnFeatureInit {
    private registry = inject(WidgetRegistryService);

    onFeatureInit(): void {
        this.registry.registerLazy(WidgetType.RotatingTeaser, RotatingTeaserWidgetComponent);
        this.registry.registerLazy(WidgetType.StaticTeaser, StaticTeaserWidgetComponent);
    }
}
